module.exports = __webpack_public_path__ + "img/face-test.543396a1.png";